'use client'

import { Dispatch, SetStateAction, useEffect } from 'react'

import { ISearchResponse } from '@/_types/search'

import { useHeaderScroll } from '../../_hooks'

import { AMobileHeaderBottom } from './a-mobile-header-bottom'
import { AMobileHeaderTop } from './a-mobile-header-top'

interface AMobileHeaderProps {
	searchOpen: boolean
	setSearchOpen: Dispatch<SetStateAction<boolean>>
	searchQuery: string
	onSearchQueryChange: (query: string) => void
	onSearchClose: () => void
	searchData: ISearchResponse | undefined
	isSearchLoading: boolean
	isSearching: boolean
	hasSearchTerm: boolean
	onMenuToggle: () => void
	onLinkClick: () => void
	menuOpen: boolean
	onHeaderTopVisibilityChange?: (isVisible: boolean) => void
}

export const AMobileHeader = ({
	searchOpen,
	setSearchOpen,
	searchQuery,
	onSearchQueryChange,
	onSearchClose,
	searchData,
	isSearchLoading,
	isSearching,
	hasSearchTerm,
	onMenuToggle,
	onLinkClick,
	menuOpen,
	onHeaderTopVisibilityChange
}: AMobileHeaderProps) => {
	const { isScrollingDown } = useHeaderScroll()

	// Notify parent when scroll state changes
	useEffect(() => {
		if (onHeaderTopVisibilityChange) {
			// Keep the callback for backwards compatibility
			onHeaderTopVisibilityChange(!isScrollingDown)
		}
	}, [isScrollingDown, onHeaderTopVisibilityChange])

	return (
		<>
			<div className='header-mobile__wrapper show_lgm'>
				<AMobileHeaderTop
					onLinkClick={onLinkClick}
					isVisible={!isScrollingDown}
					menuOpen={menuOpen}
				/>
				<AMobileHeaderBottom
					searchOpen={searchOpen}
					setSearchOpen={setSearchOpen}
					searchQuery={searchQuery}
					onSearchQueryChange={onSearchQueryChange}
					onSearchClose={onSearchClose}
					searchData={searchData}
					isSearchLoading={isSearchLoading}
					isSearching={isSearching}
					hasSearchTerm={hasSearchTerm}
					onMenuToggle={onMenuToggle}
					onLinkClick={onLinkClick}
					menuOpen={menuOpen}
				/>
				<div id='mobile-header-extra' />
			</div>
		</>
	)
}
